export const toastStyle = {
  background: "#ffffff",
  color: "rgba(0,0,0,1)",
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)", 
  borderRadius: "8px",
  padding: "8px 16px",
  fontSize: "14px",
  border: "1px solid #B8B8B8",
  textAlign: "center",
  minWidth: "auto",
  width: "fit-content",
  marginBottom: "2dvh",
};


export const tagsToAvoidOnBlurEvent = ["A"]
